export default "__VITE_ASSET__0ca3268e__"